export const LOAD_DELAY_NOTIFICATION_TIME_THRESHOLD = 1_000;
